/**
 * Local review mode: `?demo=<scenario>` swaps the API, the wallet and the chain for fakes so
 * every state of /ens and /governance can be looked at offline. It only exists on this
 * machine; on any other host the real adapters are always used.
 *
 *   off    no wallet connected
 *   on     wallet connected, with names and balances
 *   empty  wallet connected, nothing minted yet, no balances
 *   worst  long names, huge counts, huge balances
 *   error  every request fails
 *   slow   like on, with every step taking a few seconds
 *   fail   like on, but every action is refused by the server
 */

export const DEMOS = ['off', 'on', 'empty', 'worst', 'error', 'slow', 'fail'] as const;
export type Demo = (typeof DEMOS)[number];

const LOCAL_HOSTS = ['localhost', '127.0.0.1', '::1', '[::1]'];

export function demoFrom({ hostname, search }: { hostname: string; search: string }): Demo | null {
  if (!LOCAL_HOSTS.includes(hostname)) return null;
  const asked = new URLSearchParams(search).get('demo');
  return (DEMOS as readonly string[]).includes(asked || '') ? (asked as Demo) : null;
}

export const currentDemo = (): Demo | null =>
  typeof window === 'undefined' ? null : demoFrom({ hostname: window.location.hostname, search: window.location.search });
